<template>
  <div class="bg-color">
    <div class="container py-5">
      <div class="row m-0">
        <div class="col-12 col-md-7">
          <h2 class="text-primary mb-4">
            Why Choose English Matters?
          </h2>
          <ul class="style-type-none">
            <li>✔️ Expert instructors with international experience</li>
            <li>✔️ Experience learning in our WHALE room (Accelerative Learning Environment)</li>
            <li>✔️ Small class sizes for personalized attention</li>
            <li>✔️ Flexible online and in-person learning options</li>
            <li>✔️ Comprehensive curriculum with real-world applications</li>
            <li>✔️ Part of the Edu Circle Group, ensuring quality and innovation</li>
            <li>✔️ Transportation can be arranged if by demand</li>
          </ul>

          <p>
            Ready to start your learning journey? 
            <router-link class="" to="/contact">Contact Us</router-link>
            today!
          </p>
        </div> 
      </div>
    </div>
  </div>
</template>

<style scoped>
h2 { font-size: 1.8em; }

.bg-color {
  background-color: #F4F3F9;
}

ul.style-type-none {
  list-style-type: none;
}
</style>